import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import RolesApi from '../../Services/Roles';
import Alert from '../../Services/Alert';

/* Add / edit an admin user (a sub-admin). Route /admin-users/add or /admin-users/edit/:id.
   On edit, the user list already carries the fields we need, so we pull the one row from
   userList rather than adding a get-one endpoint. */
export const AdminUserForm = (props) => {
    const id = props.match.params.id || null;
    const isEdit = !!id;

    const [roles, setRoles] = useState([]);
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [roleId, setRoleId] = useState('');

    useEffect(() => {
        RolesApi.list().then(resp => {
            const r = resp.data;
            if (r.status == 1) setRoles(r.data);
            else Alert.error(r.message);
        }).catch(e => Alert.error(e.message));

        if (isEdit) {
            RolesApi.userList({ page: 1, size: 1000 }).then(resp => {
                const r = resp.data;
                if (r.status != 1) { Alert.error(r.message); return; }
                const u = (r.data.docs || []).find(x => x._id === id);
                if (!u) { Alert.error('User not found'); return; }
                setFirstname(u.firstname || '');
                setLastname(u.lastname || '');
                setEmail(u.email || '');
                setRoleId(u.role_id || '');
            }).catch(e => Alert.error(e.message));
        }
    }, [id]);

    function onSubmit(e) {
        e.preventDefault();
        if (!firstname.trim()) { Alert.error('First name is required'); return; }
        if (!email.trim()) { Alert.error('Email is required'); return; }
        if (!roleId) { Alert.error('Please select a role'); return; }
        if (!isEdit && !password.trim()) { Alert.error('Password is required'); return; }

        const payload = { firstname: firstname.trim(), lastname: lastname.trim(), email: email.trim(), role_id: roleId };
        if (password.trim()) payload.password = password.trim();

        const call = isEdit ? RolesApi.userUpdate({ id, ...payload }) : RolesApi.userCreate(payload);
        call.then(res => res.data).then(res => {
            if (res.status) { Alert.success(res.message); props.history.push('/admin-users'); }
            else Alert.error(res.message);
        }).catch(e => Alert.error(e.message));
    }

    return (
        <section className="main-content marketadd_main_sec">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title mb-4">{isEdit ? 'Edit User' : 'Add User'}</h4>
                                    <form onSubmit={onSubmit}>
                                        <div className="row">
                                            <div className="mb-3 col-lg-4">
                                                <label className="form-label">First Name</label>
                                                <input type="text" className="form-control" value={firstname} onChange={e => setFirstname(e.target.value)} />
                                            </div>
                                            <div className="mb-3 col-lg-4">
                                                <label className="form-label">Last Name</label>
                                                <input type="text" className="form-control" value={lastname} onChange={e => setLastname(e.target.value)} />
                                            </div>
                                            <div className="mb-3 col-lg-4">
                                                <label className="form-label">Email</label>
                                                <input type="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} />
                                            </div>
                                            <div className="mb-3 col-lg-4">
                                                <label className="form-label">Password {isEdit ? <small className="text-muted">(leave blank to keep)</small> : null}</label>
                                                <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" />
                                            </div>
                                            <div className="mb-3 col-lg-4">
                                                <label className="form-label">Role</label>
                                                <select className="form-control" value={roleId} onChange={e => setRoleId(e.target.value)}>
                                                    <option value="">-- Select role --</option>
                                                    {roles.map(r => <option key={r._id} value={r._id}>{r.name}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <button type="submit" className="btn btn-primary me-2">{isEdit ? 'Update' : 'Create'}</button>
                                            <button type="button" className="btn btn-light" onClick={() => props.history.push('/admin-users')}>Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withRouter(AdminUserForm);
